import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CoreDrawer,
    {
      attrs: {
        value: _vm.isVisible,
        title: _setup.title,
        "title-truncate": "",
        "data-qa": "patient-profile-modal",
      },
      on: { input: _setup.onInput },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "d-flex pa-2" },
                [
                  _c(
                    VBtn,
                    {
                      staticClass: "branding-btn branding-btn--primary",
                      attrs: {
                        "data-qa": "patient_profile__node_btn_close",
                        block: "",
                        depressed: "",
                      },
                      on: { click: _setup.close },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_setup.tStatic("Закрыть")) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(_setup.PatientProfileContent, {
        attrs: { "patient-data": _vm.patientData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }